/* tslint:disable */
/* eslint-disable */
/**
 * Thynk Direct API
 * The API for managing reservation for [Thynk Direct](https://thynk.cloud/).
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import { LocationSettingsLocationRead } from './location-settings-location-read';

/**
 *
 * @export
 * @interface LocationSettingsTranslationLocationRead
 */
export interface LocationSettingsTranslationLocationRead {
  /**
   *
   * @type {string}
   * @memberof LocationSettingsTranslationLocationRead
   */
  '@context'?: string | null;
  /**
   *
   * @type {string}
   * @memberof LocationSettingsTranslationLocationRead
   */
  '@id'?: string;
  /**
   *
   * @type {string}
   * @memberof LocationSettingsTranslationLocationRead
   */
  '@type'?: string;
  /**
   * database identifier of the location settings translation
   * @type {string}
   * @memberof LocationSettingsTranslationLocationRead
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof LocationSettingsTranslationLocationRead
   */
  type?: LocationSettingsTranslationLocationReadTypeEnum;
  /**
   *
   * @type {LocationSettingsLocationRead}
   * @memberof LocationSettingsTranslationLocationRead
   */
  locationSettings?: LocationSettingsLocationRead | null;
  /**
   * the translated value
   * @type {string}
   * @memberof LocationSettingsTranslationLocationRead
   */
  name?: string;
  /**
   * the language of the translated name
   * @type {string}
   * @memberof LocationSettingsTranslationLocationRead
   */
  language?: string;
}

export const LocationSettingsTranslationLocationReadTypeEnum = {
  WebformTaxes: 'webform_taxes',
  MeetingRoomDisclaimer: 'meeting_room_disclaimer',
  CheckoutDisclaimer: 'checkout_disclaimer',
  ThynkDirectCheckoutPopup: 'thynk_direct_checkout_popup',
  ThynkDirectPriceCalculationPopup: 'thynk_direct_price_calculation_popup',
} as const;

export type LocationSettingsTranslationLocationReadTypeEnum =
  (typeof LocationSettingsTranslationLocationReadTypeEnum)[keyof typeof LocationSettingsTranslationLocationReadTypeEnum];
